module.exports = __webpack_public_path__ + "img/broward-medical-examiners-sheriff-facility.0fd08497.jpg";